import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CardMembership from "../../components/cards/CardMembership";
import CardInfluencer from "../../components/cards/CardInfluencer";
import CardWithCollapse from "../../components/cards/CardWithCollapse";
import CardInformationToUsers from "../../components/cards/CardInformationToUsers.js";

const PantryProfile = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");
	const [members, setMembers] = useState(null); // Changed from [null] to null for easier checking
	const urlParams = useParams();

	useEffect(() => {
		setIsLoading(true);
		fetch(`/api/user-profile?uuid=${urlParams.uuid}`)
			.then((response) => {
				if (!response.ok) {
					throw Error("There was an error getting the client data");
				}
				return response.json();
			})
			.then((data) => {
				setMembers(data[0]);
			})
			.catch((err) => {
				setError(err.message);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [urlParams.uuid]);

	// Helper to check Grace Period eligibility

	const getGracePeriodStatus = () => {
		if (!members || !members.end_date) {
			return { isExpired: false, isEligible: false };
		}

		const today = new Date();
		const endDate = new Date(members.end_date);
		const graceDate = new Date(members.end_date);
		graceDate.setMonth(graceDate.getMonth() + 3);

		const ukOptions = { day: "2-digit", month: "2-digit", year: "numeric" };

		return {
			isExpired: today > endDate,
			isEligible: today > endDate && today <= graceDate,
			expiryDate: endDate.toLocaleDateString("en-GB", ukOptions),
			finalDate: graceDate.toLocaleDateString("en-GB", ukOptions),
		};
	};

	if (!members) {
		return null;
	}

	const grace = getGracePeriodStatus();

	return (
		<Grid container spacing={3}>
			<Grid item xs={12} sm={12} md={12}>
				<Stack sx={{ width: "100%" }} spacing={1}>

					{grace.isEligible && (
						<Alert variant="filled" severity="warning">
                            Your membership expired on {grace.expiryDate}.
							<strong> Grace Period Active:</strong> You can still shop until {grace.finalDate}.
                            Please renew soon!
						</Alert>
					)}

					{grace.isExpired && !grace.isEligible && (
						<Alert variant="filled" severity="error">
                            Membership Expired. Your grace period ended on {grace.finalDate}.
                            Access to shopping is now restricted.
						</Alert>
					)}

					{!grace.isExpired && members.membership_status === "Active" && (
						<Alert variant="filled" severity="success">
                            Your membership status is active.
						</Alert>
					)}

					{members.membership_status === "Active More Info Required" && (
						<Alert variant="filled" severity="warning">
                            Your membership status is active but more info required.
						</Alert>
					)}

					{members.membership_status === "Idle" && (
						<Alert variant="filled" severity="info" sx={{ bgcolor: "#a6a6a6" }}>
                            Your membership status is inactive and unpaid.
						</Alert>
					)}

					{members.membership_status === "Inactive" && (
						<Alert variant="filled" severity="error">
                            Your membership status is inactive.
						</Alert>
					)}

				</Stack>
			</Grid>

			<Grid item xs={12} sm={12} md={4}>
				<CardMembership members={members} />
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<CardInformationToUsers members={members} />
			</Grid>
			<Grid item xs={12} sm={6} md={4}>
				<CardInfluencer members={members} />
			</Grid>
		</Grid>
	);
};

export default PantryProfile;